import CalendarViewTypeEnum from '../../lib/schema/CalendarViewTypeEnum';
import { DateRangeType } from '@fluentui/date-time-utilities/lib/dateValues/dateValues';
import { assertNever } from 'owa-assert';

// NOTE -- these defaults should be updated as a group so that they stay in-sync
// NOTE -- do not change default to Board view without carefully auditing code and making additional changes elsewhere
export const DEFAULT_CALENDAR_VIEW_TYPE: CalendarViewTypeEnum = CalendarViewTypeEnum.Weekly;
export const DEFAULT_CALENDAR_DATE_RANGE_TYPE: DateRangeType = DateRangeType.Week;

/**
 * Converts provided calendar view type to its corresponding date range type, or else undefined
 */
export function CalendarViewTypeEnumToDateRangeType(
    viewType: CalendarViewTypeEnum
): DateRangeType | undefined {
    switch (viewType) {
        case CalendarViewTypeEnum.Daily:
            return DateRangeType.Day;
        case CalendarViewTypeEnum.Weekly:
            return DateRangeType.Week;
        case CalendarViewTypeEnum.WorkWeek:
            return DateRangeType.WorkWeek;
        case CalendarViewTypeEnum.Monthly:
            return DateRangeType.Month;
        // TODO: VSO #88707 Separate module vs surface concerns in Calendar module
        // this should be changed to undefined once module has been appropriately decoupled from surface
        case CalendarViewTypeEnum.Board:
            return DEFAULT_CALENDAR_DATE_RANGE_TYPE;
        // gracefully handle any unsupported values
        default:
            return DEFAULT_CALENDAR_DATE_RANGE_TYPE;
    }
}

/**
 * Converts provided date range type to its corresponding calendar view type
 */
export function DateRangeTypeToCalendarViewTypeEnum(
    dateRangeType: DateRangeType
): CalendarViewTypeEnum {
    switch (dateRangeType) {
        case DateRangeType.Day:
            return CalendarViewTypeEnum.Daily;
        case DateRangeType.Week:
            return CalendarViewTypeEnum.Weekly;
        case DateRangeType.WorkWeek:
            return CalendarViewTypeEnum.WorkWeek;
        case DateRangeType.Month:
            return CalendarViewTypeEnum.Monthly;
        default:
            assertNever(dateRangeType);
    }
}
